import { ActionResult } from '../types'
import { useDirectoryTree } from '../useDirectoryTree'

export abstract class ExecutableAction<E = undefined, U = E> {
  abstract readonly actionName: string
  abstract execute(tree: ReturnType<typeof useDirectoryTree>): Promise<ActionResult<E>>
  abstract undo(tree: ReturnType<typeof useDirectoryTree>): Promise<ActionResult<U>>
}
